import React from "react";
import titleize from "underscore.string/titleize";
import { OverviewSubheader } from "../../layouts";
import { Loaders } from "../../../components";
import {
  ResponsiveTable,
  ErrorBoundary,
} from "../..";
import { useCompanyAccountsList } from "../../../queries/company";
import usePagination from "../../../hooks/usePagination";

function AccountsList({companyId}) {
  const pageConfig = usePagination();
  const accountList = useCompanyAccountsList({company_id: companyId, ...pageConfig.current});


  const tableData = React.useMemo(
    () => {
      if (accountList.isSuccess)
        return accountList.data.data
      else
        return []
    },
    [accountList]
  );


  const columns = React.useMemo(
    () => {
      if (accountList.isSuccess){
        return [
          {
            Header: 'Account name',
            accessor: 'user.name',
            Cell: ({value}) => titleize(value)
          },{
            Header: 'Email',
            accessor: 'user.email'
          },
          {
            Header: 'Role',
            accessor: 'name'
          },
        ]
      }
      else{
        return []
      }
    },
    [accountList]
  );

  if (accountList.isLoading)
    return <Loaders.ListPageLoader />

  return (
    <ErrorBoundary>
      <OverviewSubheader left='Company Accounts' tooltipDesc="All the user accounts that are associated with your company. Currently, only Spaced Ventures can add new accounts. Please let us know if you would like a new account invite sent." />
      <ResponsiveTable title="Accounts" columns={columns} data={tableData}/>
    </ErrorBoundary>
  )
}

export default AccountsList;